module.exports = __webpack_public_path__ + "media/images/frontend/facebook-e615860d79f460975d7556facbad3b4a.png";